/* USE PROTECTION design: the menu panel (snippets/up-menu, #menu) and the device sheet (snippets/up-devices, #devices).
 *
 * The panels open and close through assets/up.js (window.upPanel, [data-u-open] / [data-u-close], the scrim, Escape,
 * events u:panel-open / u:panel-close). This file wires the live logic of the v2 drawer (snippets/glossy-drawer-v2)
 * and of the live collection bar's device sheet (sections/collection-v2) into the mockup's markup:
 *   - the lens Toate / Femei / Bărbați sets the shop's face IN PLACE through window.__mfSetFace (the head script in
 *     layout/theme.liquid owns the face; ask __mfFace(), never cache it) and announces mf:face-changed, so the grids
 *     behind top themselves up; the vibes re-rank for the face, hide where the face has too few designs (CSS) and,
 *     as in the mockup, show six (the six most sold for the face; the page's own mood leads);
 *   - "the visitor's phone": the remembered one (assets/mf-device.js, window.mfDeviceCollection) when it is a phone of
 *     the device sheet, else the device collection being viewed, else the fallback phone the server rendered.
 *     Full-Shock, Pro-Shock, "Vezi toate colecțiile", Monogram and the moods point at it (mf-device.js also rewrites
 *     the mood links by itself); Full-Shock / Pro-Shock land with the listing's own case-type filter on (the chip
 *     pressed and the grid narrowed, as the mockup's setFilter);
 *   - the moods (v2): the page's mood is marked and leads the row; tapping the marked mood clears it;
 *   - Monogram opens the letter window (snippets/mf-monogram, window.mfOpenMonogram) when it is on the page;
 *   - Collabs opens its page inside the menu (.u-msub), Înapoi closes it; "Ajutor și informații" scrolls into view
 *     when it opens (the mockup's toggle handler);
 *   - the device sheet: brand tabs, one search over every brand, the phone being viewed (else the remembered one)
 *     marked and scrolled to; a pick navigates to that phone's collection, and on a device collection the view, sort
 *     and filters (tags, case type) travel along, on a mood collection the mood does. The link's href is only swapped
 *     for the one click (follow()), so assets/mf-device.js's capture always reads the bare phone collection.
 *   - the home hero's CTA (sections/up-hero, a[data-up-pick]) works as the mockup's: it goes to the collection (the
 *     remembered phone's when there is one) and the device sheet opens on top of it there.
 *
 * WHO SAVES THE PHONE (assets/mf-device.js remembers in its capture-phase click on a.mfd__devitem), as live:
 *   - opened from the menu row "Huse după telefon": browse only - the sheet carries data-mfd-view="device"
 *     data-mfd-via="row", mf-device sends dvm:browse and saves nothing (v2 rule, merchant 2026-09-17);
 *   - opened from the collection heading (sections/up-collection, data-up-src="coll"): saved via 'coll' through
 *     window.mfRememberDevice, as the live collection bar's sheet did (its rows were not mfd__devitem); the tapped row
 *     leaves the a.mfd__devitem class for that one click so mf-device does not also save it via 'mnu';
 *   - opened for the home hero: saved via 'mnu' (mf-device's own capture) - "Alege-ți telefonul" states the phone.
 *
 * MEASUREMENT. Steps through mfTrackPush('mf_nav_step'), each series kept to its own opener:
 *   - from the menu (v2 keys): mnu:g_women | g_men | g_off, mnu:mood_click with mnu:mood_<key> / mood_off_<key>,
 *     mnu:all_designs, mnu:mono, mnu:dev_open + mnu:dev_row, mnu:dev_srch (first typed character per opening),
 *     mnu:dev_brand, mnu:dev_pick; additive: mnu:type_full / type_pro (the two case-type rows);
 *   - from the collection heading: cbar:dev_go on a pick (the live bar's key; its cbar:dev_open is sent by
 *     assets/up-lists.js from the heading's data-u-step);
 *   - from the home hero: home:hero_dev_open / home:hero_dev_pick (new; the CTA tap itself is mf-track's home:to_plp).
 * assets/mf-track.js's own menu series (menu_open / expand / back / close / link_click, click_p<n>) read the
 * data-glossy-* attributes in the markup; the header's menu button (snippets/up-header) gets data-glossy-drawer-open
 * here, and while the menu (or the sheet opened from it) is up the scrim and the tinted header bar carry
 * data-glossy-drawer-close, so a close by either is counted - nothing here stops a click from reaching mf-track.
 *
 * ACCESSIBILITY: both panels are role="dialog" aria-modal; Tab stays inside the open panel, focus goes back to the
 * opener on close, and the openers carry aria-expanded.
 *
 * ES5 (no build step, same rule as mf-track.js). Loaded deferred from snippets/up-menu, after mf-device.js.
 */
(function () {
  'use strict';
  var W = window, D = document;
  var menu = D.getElementById('menu');
  var sheet = D.getElementById('devices');
  if (!menu && !sheet) { return; }
  var reduceMotion = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* one mf_nav_step; fam = the series (mnu / cbar / home) */
  function push(fam, name) {
    try { if (W.mfTrackPush) { W.mfTrackPush('mf_nav_step', { mf_step: fam + ':' + String(name).replace(/[^a-z0-9_]/gi, '_').slice(0, 36) }); } } catch (e) {}
  }
  function step(name) { push('mnu', name); }
  /* market paths (snippets/mf-l10n; identities on RO) */
  function P(p) { return W.mfPath ? W.mfPath(p) : String(p == null ? '' : p); }
  function H(p) { return W.mfHref ? W.mfHref(p) : String(p == null ? '' : p); }
  function pathOnly(h) { return P(String(h || '').split('?')[0].split('#')[0]).replace(/\/+$/, ''); }
  function face() { return (W.__mfFace ? W.__mfFace() : (W.__mfView || '')) || ''; }
  function modified(e) { return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1; }
  var FALLBACK = (menu && menu.getAttribute('data-fallback')) || H('/collections/iphone-17-pro-max');
  /* the link goes to href for this one click and gets its own href back right after: the browser reads the href when
     the click's dispatch ends, mf-track's bubble listener reads it on the way (mf_to), and the next tap - a second
     tap while the page loads included - starts again from the link as rendered */
  function follow(a, href) {
    var was = a.getAttribute('href');
    if (!href || href === was) { return; }
    a.setAttribute('href', href);
    setTimeout(function () { a.setAttribute('href', was); }, 0);
  }

  /* mf-track's menu_open: the header's menu button carries the v2 opener's attribute */
  [].forEach.call(D.querySelectorAll('[data-u-open="menu"]'), function (b) { b.setAttribute('data-glossy-drawer-open', ''); });

  /* ── the visitor's phone ─────────────────────────────────────────────────────────────── */
  var rows = sheet ? [].slice.call(sheet.querySelectorAll('a.mfd__devitem')) : [];
  rows.forEach(function (r) { r.setAttribute('data-href0', r.getAttribute('href') || ''); });
  function rowOf(path) {
    for (var i = 0; i < rows.length; i++) {
      if (pathOnly(rows[i].getAttribute('data-href0')) === path) { return rows[i]; }
    }
    return null;
  }
  function pageDeviceRow() {
    var segs = pathOnly(W.location.pathname).split('/');
    if (segs[1] !== 'collections' || !segs[2]) { return null; }
    return rowOf('/collections/' + segs[2]);
  }
  /* the remembered phone's row; read from mf-device's memory each time (a pick, a bfcache restore and a save on a
     product page all change it after mf-device marked its .is-current at boot) */
  function savedRow() {
    var d = '';
    try { d = W.mfDeviceCollection ? W.mfDeviceCollection() : ''; } catch (e) {}
    return d ? rowOf(pathOnly(d)) : null;
  }
  /* href-ready (market-prefixed) collection path of the visitor's phone, or '' */
  function deviceBase() {
    var d = '';
    try { d = W.mfDeviceCollection ? W.mfDeviceCollection() : ''; } catch (e) {}
    d = pathOnly(d);
    /* a remembered "device" the sheet does not list (an accessory collection picked in the v2 drawer) is not a phone */
    if (d && rows.length && !rowOf(d)) { d = ''; }
    if (!d) { var r = pageDeviceRow(); if (r) { d = pathOnly(r.getAttribute('data-href0')); } }
    return d.indexOf('/collections/') === 0 ? H(d) : '';
  }
  /* The two case-type rows carry the listing's type filter as data-up-dev ("?filter.v.option.case+type=<group id>").
     Liquid can read a collection's filters only on a collection page, so elsewhere the rows come without it. The
     group ids are store-wide: kept from a collection page (localStorage, a day), else read once, when the menu opens,
     from the header section rendered on the fallback phone's collection (?section_id=, the same markup). */
  var TQ_KEY = 'up_tq1', TQ_TTL = 86400000, tqAsked = false;
  /* the rows that carry the Full-Shock / Pro-Shock filter: data-up-tq f / p (with the glossy merge on, the Full-Shock filter
     is the Slim-Shock row's and the glossy Full-Shock row is the plain collection - snippets/up-menu.liquid) */
  var typeRows = menu ? [menu.querySelector('[data-up-tq="f"]') || menu.querySelector('[data-up-step="type_full"]'), menu.querySelector('[data-up-tq="p"]') || menu.querySelector('[data-up-step="type_pro"]')] : [];
  function tqKnown() { return !!typeRows[0] && !!typeRows[1] && !!typeRows[0].getAttribute('data-up-dev') && !!typeRows[1].getAttribute('data-up-dev'); }
  function tqUse(f, p) {
    if (!/^\?filter\./.test(f || '') || !/^\?filter\./.test(p || '')) { return false; }
    typeRows[0].setAttribute('data-up-dev', f); typeRows[1].setAttribute('data-up-dev', p);
    return true;
  }
  function tqBoot() {
    if (!typeRows[0] || !typeRows[1]) { return; }
    try {
      if (tqKnown()) { W.localStorage.setItem(TQ_KEY, JSON.stringify({ f: typeRows[0].getAttribute('data-up-dev'), p: typeRows[1].getAttribute('data-up-dev'), t: new Date().getTime() })); return; }
      var c = JSON.parse(W.localStorage.getItem(TQ_KEY) || 'null');
      if (c && new Date().getTime() - c.t < TQ_TTL) { tqUse(c.f, c.p); }
    } catch (e) {}
  }
  function tqFetch() {
    if (tqAsked || tqKnown() || !typeRows[0] || !W.fetch || !W.DOMParser) { return; }
    tqAsked = true;
    var sec = menu.closest('.shopify-section');
    var id = sec ? sec.id.replace(/^shopify-section-/, '') : '';
    if (!id) { return; }
    W.fetch(FALLBACK + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) { return; }
      var d = new W.DOMParser().parseFromString(html, 'text/html');
      var f = d.querySelector('#menu [data-up-tq="f"]') || d.querySelector('#menu [data-up-step="type_full"]'), p = d.querySelector('#menu [data-up-tq="p"]') || d.querySelector('#menu [data-up-step="type_pro"]');
      if (f && p && tqUse(f.getAttribute('data-up-dev'), p.getAttribute('data-up-dev'))) {
        try { W.localStorage.setItem(TQ_KEY, JSON.stringify({ f: f.getAttribute('data-up-dev'), p: p.getAttribute('data-up-dev'), t: new Date().getTime() })); } catch (e) {}
        pointLinks();
      }
    }).catch(function () {});
  }
  tqBoot();

  /* snippets/mf-monogram lists the same phone the menu links follow (v2 published this too) */
  W.mfMenuDeviceBase = deviceBase;
  function pointLinks() {
    if (!menu) { return; }
    var base = deviceBase() || FALLBACK;
    [].forEach.call(menu.querySelectorAll('[data-up-dev]'), function (a) { a.setAttribute('href', base + (a.getAttribute('data-up-dev') || '')); });
  }

  /* ── the moods (v2): single select, the page's mood leads and is marked, a second tap clears it ── */
  var moodRow = menu ? menu.querySelector('[data-mvibes]') : null;
  /* the mockup's row showed six moods; the design categories (owner 2026-11-04) show all: data-max on the row */
  var MOOD_MAX = (moodRow && +moodRow.getAttribute('data-max')) || 6;
  var moods = moodRow ? [].slice.call(moodRow.querySelectorAll('a[data-mfd-mood]')) : [];
  moods.forEach(function (a, i) { a.setAttribute('data-order', String(i)); });
  function moodKeys() { return moods.map(function (t) { return t.getAttribute('data-mfd-mood'); }); }
  function tagHandle(t) {
    var v = String(t || '').toLowerCase();
    try { v = decodeURIComponent(v.replace(/\+/g, ' ')); } catch (eD) {}
    try { v = v.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (eN) {}
    return v.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function moodOfPage() {
    var path = pathOnly(W.location.pathname), segs = path.split('/');
    var inPath = segs.length > 3 ? segs[3].split('+').map(tagHandle) : [];
    var inQuery = [];
    try { new URLSearchParams(W.location.search).getAll('filter.p.tag').forEach(function (v) { inQuery.push(tagHandle(v)); }); } catch (eQ) {}
    for (var i = 0; i < moods.length; i++) {
      var a = moods[i], key = a.getAttribute('data-mfd-mood') || '';
      if (pathOnly(a.getAttribute('data-mfd-href0')) === path) { return a; }
      if (inPath.indexOf(key) > -1 || inQuery.indexOf(key) > -1) { return a; }
    }
    return null;
  }
  /* "no mood": the same page without its mood; on a mood collection, the visitor's phone (v2). Href-ready. */
  function moodOffHref() {
    var path = pathOnly(W.location.pathname), segs = path.split('/'), keys = moodKeys();
    for (var i = 0; i < moods.length; i++) {
      if (pathOnly(moods[i].getAttribute('data-mfd-href0')) === path) { return deviceBase() || FALLBACK; }
    }
    var sp = null;
    try { sp = new URLSearchParams(W.location.search); } catch (eS) {}
    if (sp) {
      var keep = sp.getAll('filter.p.tag').filter(function (v) { return keys.indexOf(tagHandle(v)) < 0; });
      sp.delete('filter.p.tag'); sp.delete('page');
      keep.forEach(function (v) { sp.append('filter.p.tag', v); });
    }
    var qs = sp ? sp.toString() : '';
    if (segs.length > 3) {
      var rest = segs[3].split('+').filter(function (x) { return keys.indexOf(tagHandle(x)) < 0; });
      return H(segs.slice(0, 3).join('/') + (rest.length ? '/' + rest.join('+') : '') + (qs ? '?' + qs : ''));
    }
    return H(path + (qs ? '?' + qs : ''));
  }
  function orderAttr() { var f = face(); return f === 'women' ? 'data-order-w' : (f === 'men' ? 'data-order-m' : 'data-order'); }
  /* the face rule of up-skin-menu.css (data-g: w = all + women, m = all + men, x = all only) */
  function moodOnFace(t, f) {
    var g = t.getAttribute('data-g') || '';
    if (f === 'women') { return g !== 'm' && g !== 'x'; }
    if (f === 'men') { return g !== 'w' && g !== 'x'; }
    return true;
  }
  function settleMoods() {
    if (!moodRow) { return; }
    var sel = moodOfPage(), attr = orderAttr(), f = face();
    moods.forEach(function (t) { if (t === sel) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); } });
    var list = moods.slice().sort(function (x, y) {
      return ((+x.getAttribute(attr)) - (+y.getAttribute(attr))) || ((+x.getAttribute('data-order')) - (+y.getAttribute('data-order')));
    });
    if (sel) { list.splice(list.indexOf(sel), 1); list.unshift(sel); }
    /* the first six the face shows; the rest wait (data-up-cap) */
    var shown = 0;
    list.forEach(function (t) {
      moodRow.appendChild(t);
      var on = t === sel || moodOnFace(t, f);
      if (on && shown < MOOD_MAX) { shown++; t.removeAttribute('data-up-cap'); } else if (on) { t.setAttribute('data-up-cap', ''); } else { t.removeAttribute('data-up-cap'); }
    });
    /* "Saját fotó" (the Custom Studio tile) stays last whatever the face's order */
    [].forEach.call(moodRow.querySelectorAll('[data-up-last]'), function (x) { moodRow.appendChild(x); });
    moodRow.scrollLeft = 0;
  }
  if (moodRow) {
    /* desktop: a plain mouse wheel scrolls the row sideways while it has somewhere to go (v2) */
    moodRow.addEventListener('wheel', function (ev) {
      if (Math.abs(ev.deltaY) <= Math.abs(ev.deltaX)) { return; }
      var max = moodRow.scrollWidth - moodRow.clientWidth;
      var next = Math.max(0, Math.min(max, moodRow.scrollLeft + ev.deltaY));
      if (max <= 0 || next === moodRow.scrollLeft) { return; }
      ev.preventDefault();
      moodRow.scrollLeft = next;
    }, { passive: false });
  }

  /* ── the lens ──────────────────────────────────────────────────────────────────────────── */
  var lens = menu ? menu.querySelector('[data-up-lens]') : null;
  function paintFaces() {
    if (!lens) { return; }
    var f = face();
    [].forEach.call(lens.querySelectorAll('[data-up-g]'), function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-up-g') || '') === f ? 'true' : 'false'); });
  }
  if (lens) {
    lens.addEventListener('click', function (e) {
      var b = e.target.closest('[data-up-g]');
      if (!b) { return; }
      var next = b.getAttribute('data-up-g') || '';
      if (next === face()) { return; }
      step(next ? ('g_' + next) : 'g_off');
      if (W.__mfSetFace) { W.__mfSetFace(next); } else if (W.__mfSetGender) { W.__mfSetGender(next); }
      paintFaces();
      settleMoods();
      try { D.dispatchEvent(new CustomEvent('mf:face-changed', { detail: { face: next, source: 'menu' } })); } catch (eF) {}
    });
  }
  /* the face changed elsewhere (the collection bar, a bfcache restore - assets/mf-face.js): paint to __mfFace() only */
  D.addEventListener('mf:face-changed', function (ev) {
    paintFaces();
    if (ev && ev.detail && ev.detail.source === 'menu') { return; }
    settleMoods();
  });

  /* ── the menu's clicks ─────────────────────────────────────────────────────────────────── */
  function closeSubs() {
    if (!menu) { return; }
    [].forEach.call(menu.querySelectorAll('.u-msub.u-on'), function (m) { m.classList.remove('u-on'); m.setAttribute('aria-hidden', 'true'); });
    [].forEach.call(menu.querySelectorAll('[data-up-sub]'), function (o) { o.setAttribute('aria-expanded', 'false'); });
  }
  if (menu) {
    menu.addEventListener('click', function (e) {
      var t = e.target;
      var sub = t.closest('[data-up-sub]');
      if (sub) {
        var m = D.getElementById(sub.getAttribute('data-up-sub'));
        if (m) { m.classList.add('u-on'); m.setAttribute('aria-hidden', 'false'); m.scrollTop = 0; sub.setAttribute('aria-expanded', 'true'); }
        return;
      }
      if (t.closest('[data-up-back]')) { closeSubs(); return; }
      var named = t.closest('[data-up-step]');
      if (named) { step(named.getAttribute('data-up-step')); }
      var mono = t.closest('[data-up-mono]');
      if (mono) {
        step('mono');
        /* the letter window instead of the listing (v2, merchant 2026-09-17); a new tab keeps the link. The tile
           carries data-action, mf-track's mark for a JS control, so the listing layer does not count it as outbound. */
        if (W.mfOpenMonogram && !modified(e)) {
          e.preventDefault();
          if (W.upPanel) { W.upPanel.close(); }
          W.mfOpenMonogram();
        }
        return;
      }
      var mood = t.closest('a[data-mfd-mood]');
      if (mood) {
        var wasOn = mood.getAttribute('aria-current') === 'true';
        var key = mood.getAttribute('data-mfd-mood') || '';
        /* a mood keeps the phone: the visitor's phone + the mood's tag path; without one, the mood's own collection */
        var base = wasOn ? '' : deviceBase();
        var target = wasOn ? moodOffHref() : (base ? base + '/' + key : (mood.getAttribute('data-mfd-href0') || mood.getAttribute('href') || ''));
        step('mood_click');
        step((wasOn ? 'mood_off_' : 'mood_') + key);
        follow(mood, target);
      }
    });
    /* "Ajutor și informații": the opened list is brought into view (the mockup's toggle handler, block end) */
    var help = menu.querySelector('.u-mhelpd');
    var mbody = menu.querySelector('.u-p-body');
    if (help && mbody) {
      help.addEventListener('toggle', function () {
        if (!help.open) { return; }
        var over = help.getBoundingClientRect().bottom - mbody.getBoundingClientRect().bottom;
        if (over <= 0) { return; }
        try { mbody.scrollBy({ top: Math.ceil(over), behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (eH) { mbody.scrollTop += Math.ceil(over); }
      });
    }
  }

  /* ── the device sheet ──────────────────────────────────────────────────────────────────── */
  var src = 'other';
  /* where the sheet was opened from - read before up.js opens it (capture phase): data-up-src on the opener (row =
     the menu row, coll = the collection heading), else the collection section around it */
  D.addEventListener('click', function (e) {
    var o = e.target && e.target.closest ? e.target.closest('[data-u-open="devices"]') : null;
    if (o) { src = o.getAttribute('data-up-src') || (o.closest('[data-u-coll]') ? 'coll' : 'other'); }
  }, true);
  /* the series each opener reports into (see MEASUREMENT above); the collection heading's are sent apart, others none */
  function srcStep(name) {
    if (src === 'row') { step(name); } else if (src === 'hero') { push('home', 'hero_' + name); }
  }

  var dq = sheet ? sheet.querySelector('[data-up-dq]') : null;
  var brandsBox = sheet ? sheet.querySelector('[data-up-brands]') : null;
  var tabs = brandsBox ? [].slice.call(brandsBox.querySelectorAll('[data-b]')) : [];
  var empty = sheet ? sheet.querySelector('[data-up-devempty]') : null;
  var brand = tabs.length ? tabs[0].getAttribute('data-b') : '';
  var searched = false;
  function fold(t) {
    var v = String(t || '').toLowerCase();
    try { v = v.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (eN) {}
    return v.replace(/\s+/g, '');
  }
  var BRAND_WORDS = /^(apple|samsung|galaxy|xiaomi|huawei|oneplus)/;
  function renderSheet() {
    var q = dq ? fold(dq.value) : '';
    var q2 = q.replace(BRAND_WORDS, '').replace(BRAND_WORDS, '');
    if (brandsBox) { brandsBox.hidden = !!q; }
    tabs.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-b') === brand ? 'true' : 'false'); });
    var n = 0;
    rows.forEach(function (r) {
      var b = r.getAttribute('data-b') || '', hit;
      if (q) {
        var f = r.getAttribute('data-fold') || '', bf = (r.getAttribute('data-bfold') || '') + f;
        hit = f.indexOf(q) > -1 || bf.indexOf(q) > -1 || (!!q2 && f.replace(BRAND_WORDS, '').indexOf(q2) > -1);
      } else {
        hit = !brand || !b || b === brand;
      }
      r.hidden = !hit;
      if (hit) { n++; }
    });
    if (empty) {
      empty.hidden = n > 0;
      var qo = empty.querySelector('[data-up-q]');
      if (qo) { qo.textContent = dq ? dq.value : ''; }
    }
  }
  /* the selected brand tab in view when the tabs scroll (a fifth brand) */
  function showTab() {
    if (!brandsBox || brandsBox.scrollWidth <= brandsBox.clientWidth) { return; }
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-b') !== brand) { continue; }
      var t = tabs[i], left = t.offsetLeft - brandsBox.clientLeft, right = left + t.offsetWidth;
      if (left < brandsBox.scrollLeft) { brandsBox.scrollLeft = left - 3; }
      else if (right > brandsBox.scrollLeft + brandsBox.clientWidth) { brandsBox.scrollLeft = right - brandsBox.clientWidth + 3; }
      return;
    }
  }
  /* the phone being viewed, else the remembered one; one tick (aria-current) */
  function markRows() {
    var cur = pageDeviceRow() || savedRow();
    if (!cur) { for (var i = 0; i < rows.length; i++) { if (rows[i].classList.contains('is-current')) { cur = rows[i]; break; } } }
    rows.forEach(function (r) { if (r === cur) { r.setAttribute('aria-current', 'true'); } else { r.removeAttribute('aria-current'); } });
    return cur;
  }
  function openSheet() {
    if (dq) { dq.value = ''; }
    searched = false;
    var cur = markRows();
    if (cur && cur.getAttribute('data-b')) { brand = cur.getAttribute('data-b'); }
    else if (tabs.length) { brand = tabs[0].getAttribute('data-b'); }
    if (brandsBox) { brandsBox.scrollLeft = 0; }
    renderSheet();
    showTab();
    var body = sheet.querySelector('.u-p-body');
    if (body) { body.scrollTop = 0; }
    /* the marked phone in view, the search kept on screen when it fits (scrolled only when the row is below the fold) */
    if (cur && body) {
      setTimeout(function () {
        var y = cur.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop;
        if (y + cur.offsetHeight > body.clientHeight) { body.scrollTop = Math.max(0, y - body.clientHeight * 0.6); }
      }, 30);
    }
    /* mf-device.js: a pick from the menu row only browses (v2); any other opener saves */
    if (src === 'row') { sheet.setAttribute('data-mfd-view', 'device'); sheet.setAttribute('data-mfd-via', 'row'); }
    else { sheet.removeAttribute('data-mfd-view'); sheet.removeAttribute('data-mfd-via'); }
    srcStep('dev_open');
    if (src === 'row') { step('dev_row'); }
  }
  if (sheet) {
    if (dq) {
      dq.addEventListener('input', function () {
        if (!searched && dq.value) { searched = true; if (src === 'row') { step('dev_srch'); } }
        renderSheet();
      });
    }
    /* the collection heading's pick is saved via 'coll' below: the tapped row is not an a.mfd__devitem for mf-device's
       capture (documentElement) during this one click - window capture runs before it */
    W.addEventListener('click', function (e) {
      if (src !== 'coll' || !sheet.classList.contains('u-on')) { return; }
      var a = e.target && e.target.closest ? e.target.closest('a.mfd__devitem') : null;
      if (!a || !sheet.contains(a)) { return; }
      a.classList.remove('mfd__devitem');
      setTimeout(function () { a.classList.add('mfd__devitem'); }, 0);
    }, true);
    sheet.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-b]');
      if (tab && brandsBox && brandsBox.contains(tab)) {
        brand = tab.getAttribute('data-b') || '';
        renderSheet();
        showTab();
        if (src === 'row') { step('dev_brand'); }
        return;
      }
      var a = e.target.closest('a[data-href0]');
      if (!a) { return; }
      /* the phone's collection; on a device collection the view / sort / filters travel, on a mood collection the mood */
      var bare = pathOnly(a.getAttribute('data-href0'));
      var target = bare;
      try {
        if (pageDeviceRow()) {
          var segs = pathOnly(W.location.pathname).split('/');
          var view = segs.length > 3 ? segs.slice(3).join('/') : '';
          var keep = new URLSearchParams();
          /* sort and every storefront filter (tags, the case type): the filter values are store-wide, so they hold
             on the new phone's collection; the load-more page does not travel */
          new URLSearchParams(W.location.search).forEach(function (v, k) {
            if (k === 'sort_by' || k.indexOf('filter.') === 0) { keep.append(k, v); }
          });
          var qs = keep.toString();
          target = bare + (view ? '/' + view : '') + (qs ? '?' + qs : '');
        } else {
          var m = moodOfPage();
          if (m && pathOnly(m.getAttribute('data-mfd-href0')) === pathOnly(W.location.pathname)) { target = bare + '/' + m.getAttribute('data-mfd-mood'); }
        }
      } catch (eT) {}
      if (src === 'coll') {
        /* the live collection bar: remembered via 'coll', the local path stored */
        try { if (W.mfRememberDevice) { W.mfRememberDevice((a.textContent || '').replace(/^\s+|\s+$/g, ''), bare); } } catch (eR) {}
        push('cbar', 'dev_go');
      } else {
        srcStep('dev_pick');
      }
      follow(a, H(target));
    });
  }

  /* ── the home hero: the collection, with the sheet on top (the mockup's data-go="colectie" data-pick="1") ──── */
  var PICK_KEY = 'up_pick';
  D.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-up-pick]') : null;
    if (!a) { return; }
    /* document capture: ahead of mf-track's documentElement listeners, which read the link for home:to_plp */
    var base = deviceBase();
    if (base) { follow(a, base); }
    if (modified(e)) { return; }
    try { W.sessionStorage.setItem(PICK_KEY, String(new Date().getTime())); } catch (eS) {}
  }, true);
  function pickOnArrival() {
    var t = 0;
    try { t = +(W.sessionStorage.getItem(PICK_KEY) || 0); W.sessionStorage.removeItem(PICK_KEY); } catch (eS) { return; }
    if (!t || new Date().getTime() - t > 30000 || !sheet || !W.upPanel) { return; }
    if (pathOnly(W.location.pathname).indexOf('/collections/') !== 0) { return; }
    src = 'hero';
    W.upPanel.open('devices');
  }

  /* ── open / close ──────────────────────────────────────────────────────────────────────── */
  var header = D.querySelector('store-header.header');
  var opener = null;
  /* the opener that gets focus back: the trigger tapped (capture, before up.js opens) */
  D.addEventListener('click', function (e) {
    var o = e.target && e.target.closest ? e.target.closest('[data-u-open="menu"], [data-u-open="devices"]') : null;
    if (o) { opener = o; }
  }, true);
  function triggers(id) { return D.querySelectorAll('[data-u-open="' + id + '"]'); }
  function visible(el) { return !!el && el.getClientRects().length > 0 && !el.closest('.u-panel:not(.u-on)') && !el.closest('[aria-hidden="true"]'); }

  D.addEventListener('u:panel-open', function (e) {
    var id = e.detail && e.detail.id;
    var mine = id === 'menu' || id === 'devices';
    var viaMenu = id === 'menu' || (id === 'devices' && src === 'row');
    if (menu) { menu.classList.toggle('is-open', id === 'menu'); }
    if (sheet) {
      sheet.classList.toggle('is-open', id === 'devices');
      /* the sheet opened from the menu IS the menu's device view for mf-track (v2 had it inside the drawer) */
      if (id === 'devices') {
        if (viaMenu) { sheet.setAttribute('data-glossy-drawer', ''); } else { sheet.removeAttribute('data-glossy-drawer'); }
        var x = sheet.querySelector('.u-p-head [data-u-close]');
        if (x) { if (viaMenu) { x.setAttribute('data-glossy-drawer-close', ''); } else { x.removeAttribute('data-glossy-drawer-close'); } }
      }
    }
    /* the scrim and the tinted header bar close the panel (up.js reads data-u-close); while the menu is up they are
       mf-track's close too */
    var scrim = D.querySelector('.u-scrim');
    [scrim, header].forEach(function (el) {
      if (!el) { return; }
      if (mine && viaMenu) { el.setAttribute('data-glossy-drawer-close', ''); } else { el.removeAttribute('data-glossy-drawer-close'); }
    });
    if (header) { if (mine) { header.setAttribute('data-u-close', ''); } else { header.removeAttribute('data-u-close'); } }
    if (mine) { [].forEach.call(triggers(id), function (t) { t.setAttribute('aria-expanded', 'true'); }); }
    if (id === 'menu') { closeSubs(); pointLinks(); paintFaces(); settleMoods(); tqFetch(); }
    if (id === 'devices' && sheet) { openSheet(); }
    if (id !== 'devices') { src = 'other'; }
  });
  D.addEventListener('u:panel-close', function (e) {
    var id = e.detail && e.detail.id;
    if (id !== 'menu' && id !== 'devices') { return; }
    var panel = id === 'menu' ? menu : sheet;
    if (id === 'menu' && menu) { menu.classList.remove('is-open'); closeSubs(); }
    if (id === 'devices' && sheet) { sheet.classList.remove('is-open'); src = 'other'; }
    [D.querySelector('.u-scrim'), header].forEach(function (el) { if (el) { el.removeAttribute('data-glossy-drawer-close'); } });
    if (header) { header.removeAttribute('data-u-close'); }
    [].forEach.call(triggers(id), function (t) { t.setAttribute('aria-expanded', 'false'); });
    /* focus back to the opener (the menu button when the opener was inside the closed menu); only when focus is
       left inside the closed panel or on the page itself - a panel opened next takes it in up.js */
    var act = D.activeElement;
    if (act && act !== D.body && panel && !panel.contains(act)) { return; }
    var back = visible(opener) ? opener : null;
    if (!back) { [].forEach.call(triggers('menu'), function (t) { if (!back && visible(t)) { back = t; } }); }
    setTimeout(function () {
      if (W.upPanel && W.upPanel.current()) { return; }
      try { if (back) { back.focus({ preventScroll: true }); } } catch (eF) {}
    }, 0);
  });

  /* Tab stays inside the open panel (role="dialog" aria-modal) */
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !W.upPanel) { return; }
    var id = W.upPanel.current();
    var panel = id === 'menu' ? menu : (id === 'devices' ? sheet : null);
    if (!panel) { return; }
    var list = [].filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'), function (el) {
      return el.getClientRects().length > 0 && !el.hidden && !el.closest('[aria-hidden="true"]');
    });
    if (!list.length) { return; }
    var first = list[0], last = list[list.length - 1], act = D.activeElement;
    if (!panel.contains(act) || act === panel) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && act === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && act === last) { e.preventDefault(); first.focus(); }
  });

  /* a page restored by Back shows the rows' and the moods' own links again (follow() normally gives them back) */
  W.addEventListener('pageshow', function () {
    rows.forEach(function (r) { r.setAttribute('href', r.getAttribute('data-href0') || r.getAttribute('href')); });
  });

  /* first paint of the closed menu: the right face, the right order, the phone's links */
  paintFaces();
  settleMoods();
  pointLinks();
  if (sheet) { renderSheet(); }
  /* the hero's pick, on arrival (up.js is deferred too and may come later in the document) */
  if (W.upPanel) { pickOnArrival(); } else { D.addEventListener('DOMContentLoaded', pickOnArrival); }
})();
